import { apiClient } from './client';
import { BulletinComment } from '../types/bulletinComment';

export async function fetchBulletinComments(postId: number): Promise<BulletinComment[]> {
  const { data } = await apiClient.get<BulletinComment[]>(`/bulletins/${postId}/comments`);
  return data;
}

export async function createBulletinComment(
  postId: number,
  content: string,
  files: File[]
): Promise<BulletinComment> {
  const formData = new FormData();
  if (content.trim()) {
    formData.append('content', content.trim());
  }
  files.forEach((file) => formData.append('files', file));
  const { data } = await apiClient.post<BulletinComment>(
    `/bulletins/${postId}/comments`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return data;
}

export async function deleteBulletinComment(postId: number, commentId: number): Promise<void> {
  await apiClient.delete(`/bulletins/${postId}/comments/${commentId}`);
}

export async function downloadBulletinCommentAttachment(
  postId: number,
  commentId: number,
  attachmentId: number,
  fileName: string
): Promise<void> {
  const { data } = await apiClient.get<Blob>(
    `/bulletins/${postId}/comments/${commentId}/attachments/${attachmentId}/download`,
    { responseType: 'blob' }
  );
  const url = window.URL.createObjectURL(data);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  window.URL.revokeObjectURL(url);
}
